import { useState, useEffect } from 'react';
import "./TagRenameModal.css";
import Modal from "../shared/Modal";

type TagRenameModalProps = {
    isOpen: boolean;
    defaultValue: string;
    onClose: () => void;
    onSubmit: (name: string) => void;
}

export const TagRenameModal = ({isOpen, onClose, onSubmit, defaultValue}: TagRenameModalProps) => {

    const [name, setName] = useState<string>(defaultValue);
    // console.log("[FormRenameModal] isOpen: ", isOpen);

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="tag-rename-container">

                <div className="modal-title">
                    Rename Tag
                </div>
                
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoFocus={true}
                />

                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    >
                            Cancel
                    </button>
                    <button
                        className="button-save"
                        onClick={() => {
                            onSubmit(name);
                        }}
                        disabled={name === ""}
                    >
                        Submit
                    </button>
                </div>
                

              
            </div>
      </Modal>
    )
}